import React from "react";
import Page from "../templates/support/childrin&education/spotlight/t-e-a-project";
import { Helmet } from "react-helmet";

export default function home() {
  return (
    <div>
      <Helmet>
        <title>
          T.E.A Project | Youth Empowerment program Sri Lanka | Hirdaramani
        </title>
        <meta
          name="title"
          content="T.E.A Project | Youth Empowerment program Sri Lanka | Hirdaramani"
        />
        <meta
          name="description"
          content="Find out more about the  Project supports children from economically challenged communities, regardless of cultural or religious background."
        />
        <link
          rel="canonical"
          href="https://sustainability.hirdaramani.com/support/children&education/spotlight-t-e-a-project/"
        />
        <meta property="og:locale" content="en_US" />
        <meta name="keywords" content="Youth Empowerment program" />
        <meta
          property="og:title"
          content="T.E.A Project | Youth Empowerment program Sri Lanka | Hirdaramani"
        />
        <meta
          property="og:description"
          content="Find out more about the  Project supports children from economically challenged communities, regardless of cultural or religious background."
        />
        <meta
          property="og:image"
          content="https://hirdaramani-microsite.sgp1.digitaloceanspaces.com/images/logo.png"
        />
        <meta
          property="og:url"
          content="https://sustainability.hirdaramani.com/support/children&education/spotlight-t-e-a-project/"
        />
      </Helmet>

      <Page />
    </div>
  );
}
